// extracted by mini-css-extract-plugin
export default {"text":"LoginAvatar_text__hBvQa","testclass":"LoginAvatar_testclass__hsaXW","loginDropdown":"LoginAvatar_loginDropdown__GweEw"};